export default "__VITE_ASSET__Bg1N6Ch3__"